import React from "react";
import { Redirect } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/UserProfile";
// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Common Data Modules Pages
import { settingsRoutes } from "./Settings";
import NotFound from "pages/NotFound";
import ConfirmMail from "pages/Authentication/ConfirmMail";
import ResetPassword from "pages/Authentication/ResetPassword";
import { motorPaths } from "common/data/routePaths";
import { motorRoutes } from "./Motors";
import { GeneralRoutes } from "./General";

const authProtectedRoutes = [
  // settings routes
  ...settingsRoutes,
  // motor routed
  ...motorRoutes,
  // general Routes
  ...GeneralRoutes,
  { path: "/profile", component: UserProfile },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: () => <Redirect to={motorPaths.fnol} />,
  },

  // 404 Page
  { path: "*", component: NotFound },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/confirm-mail", component: ConfirmMail },
  { path: "/new-password", component: ResetPassword },
];
export { authProtectedRoutes, publicRoutes };
